import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Instrument fetch to debug Firebase emulator OAuth flow
if (typeof window !== 'undefined' && typeof window.fetch === 'function' && !window.__emulatorFetchLoggerInstalled) {
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    try {
      const url = typeof input === 'string' ? input : input?.url;
      const method = init?.method || (typeof input === 'object' && input?.method) || 'GET';
      if (url?.includes('/emulator/auth/handler')) {
        const bodyPreview =
          init?.body && typeof init.body === 'string'
            ? init.body.slice(0, 200)
            : init?.body instanceof URLSearchParams
              ? init.body.toString()
              : init?.body
                ? '[body: non-string]'
                : null;
        console.log('[FETCH][EMULATOR] outbound', { method, url, bodyPreview });
      }
      const response = await originalFetch(input, init);
      if (url?.includes('/emulator/auth/handler')) {
        const clone = response.clone();
        let responsePreview = '<non-text response>';
        try {
          responsePreview = await clone.text();
        } catch (err) {
          responsePreview = `<failed to read: ${err?.message || err}>`;
        }
        console.log('[FETCH][EMULATOR] inbound', { method, url, status: response.status, responsePreview });
      }
      return response;
    } catch (error) {
      console.error('[FETCH][EMULATOR] intercepted fetch failed', error);
      throw error;
    }
  };
  window.__emulatorFetchLoggerInstalled = true;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);